import React from 'react';
import { ChevronRight } from 'lucide-react';
interface PathStepsProps {
  steps: string[];
  tone?: 'dark' | 'light';
  highlightLast?: boolean;
}
export function PathSteps({
  steps,
  tone = 'light',
  highlightLast = true
}: PathStepsProps) {
  const dark = tone === 'dark';
  return <ol className="flex flex-wrap items-center justify-center gap-x-1.5 gap-y-2" data-id="element-231" data-mp="17dtjfpwk5tzj">
      {steps.map((step, index) => {
      const last = index === steps.length - 1;
      const pill = last && highlightLast ? 'bg-orange text-white' : dark ? 'bg-white/10 text-white border border-white/15' : 'bg-seafoam-light text-forest border border-seafoam';
      return <li key={step} className="flex items-center gap-1.5" data-id="element-232" data-mp="1q3hzydznx7vd" data-mpi={index}>
            <span className={`px-3 py-1.5 rounded-full text-xs sm:text-sm font-bold uppercase tracking-wide whitespace-nowrap ${pill}`} data-id="element-233" data-mp="1q64fazssoro5">
              {step}
            </span>
            {!last && <ChevronRight size={16} aria-hidden="true" className={dark ? 'text-seafoam' : 'text-seafoam-dark'} data-id="element-234" data-mp="2q9x23gxaafua" />}
          </li>;
    })}
    </ol>;
}